
import { NavLink } from 'react-router-dom';

export const LinkNavegacion = ({enlace, titulo, icon: Icon, tooltip}) => (
    <NavLink to={enlace} 
        className="btn btn-app bg-primary" 
        data-tooltip-id="tooltiparriba"
        data-tooltip-content={tooltip || titulo}
        style={{
            display: 'inline-flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2px 8px'
        }}>
        <Icon color="black" /> 
        <span style={{ marginTop: 6 }}>{titulo}</span>
    </NavLink> 
);